var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{attrs:{"autocomplete":"","disabled":_vm.disabled},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('vs-select-item',{attrs:{"value":"산업재해","text":"산업재해"}}),_c('vs-select-item',{attrs:{"value":"업무상재해","text":"업무상재해"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }